import React from "react";
import { GridCellKind, measureTextCached } from "@glideapps/glide-data-grid";
import { rowHeight } from "../types.js";
import { GlideCell } from "./GlideCell.js";
class GlideLinkCell extends GlideCell {
  _navigate;
  _cellKind = "link";
  constructor(valueGetter, navigate) {
    super(valueGetter);
    this._navigate = navigate;
  }
  getRenderer(muiTheme) {
    return {
      kind: GridCellKind.Custom,
      isMatch: (cell) => cell.data.kind === this._cellKind,
      needsHover: true,
      needsHoverPosition: true,
      draw: (args, cell) => {
        const { ctx, theme, rect, hoverX, hoverY, overrideCursor } = args;
        const drawArea = this.getDrawArea(rect, theme);
        const fontSizeProperty = muiTheme.typography.body1.fontSize;
        const fontSize = typeof fontSizeProperty === "string" ? Number.parseInt(fontSizeProperty) : fontSizeProperty;
        ctx.font = `${fontSize}px ${theme.fontFamily}`;
        ctx.fillStyle = muiTheme.palette.primary.main;
        ctx.fillText(cell.data.value.title, drawArea.x, drawArea.y + rowHeight / 2);
        const textMetrics = measureTextCached(cell.data.value.title, ctx);
        const textRect = this.getRectangleWithText(textMetrics, drawArea, theme);
        ctx.fillRect(drawArea.x, drawArea.y + (rowHeight + fontSize) / 2, textMetrics.width, 1);
        if (hoverX >= textRect.x && hoverX <= textRect.x + textRect.width && hoverY >= textRect.y && hoverY <= textRect.y + textRect.height) {
          overrideCursor("pointer");
        }
      },
      onClick: (args) => {
        const { cell, bounds, posX, posY, theme } = args;
        let result = void 0;
        const fontSize = 14;
        const font = `${fontSize}px ${theme.fontFamily}`;
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d", { alpha: false });
        ctx.font = font;
        const textMetrics = measureTextCached(cell.data.value.title, ctx);
        if (textMetrics) {
          const rect = this.getRectangleWithText(textMetrics, bounds, theme);
          const isLinkClicked = posX >= rect.x && posX <= rect.x + rect.width && posY >= rect.y && posY <= rect.y + rect.height;
          if (isLinkClicked && args.cell.data?.value?.onClick) {
            args.cell.data.value.onClick();
            result = cell;
          }
        }
        return result;
      }
    };
  }
  getCustomContent({ title, onClick }) {
    return {
      kind: GridCellKind.Custom,
      copyData: title,
      data: {
        kind: this._cellKind,
        value: { title, onClick },
        tooltip: TextCellTooltipContent
      },
      allowOverlay: false
    };
  }
  formatValue(value) {
    if (!value.onClick && !value.path || value?.title && typeof value?.title !== "string" || value?.path && typeof value?.path !== "string") {
      throw new Error(`Invalid value: ${JSON.stringify(value)}`);
    }
    return { title: value?.title, onClick: () => value.path ? this._navigate(value?.path) : value.onClick() };
  }
  isCellEmpty(value, isSummary) {
    return isSummary || !value?.title || !value?.onClick;
  }
  getRectangleWithText(metrics, rect, theme) {
    const x = theme.cellHorizontalPadding;
    const y = rect.height / 2 - metrics.actualBoundingBoxAscent / 2;
    const width = metrics.width;
    const height = 14 + metrics.actualBoundingBoxAscent / 2 + 1;
    return { x, y, width, height };
  }
}
function TextCellTooltipContent({ value }) {
  return /* @__PURE__ */ React.createElement("div", null, value?.title);
}
export {
  GlideLinkCell
};
//# sourceMappingURL=GlideLinkCell.js.map
